const APP_TITLE_SUFFIX = "Городская мастерская";

const EXACT_ROUTE_TITLES: Record<string, string> = {
  "/": "Главная",
  "/profile": "Профиль",
  "/subscription": "Подписка",
  "/support": "Поддержка",
  "/signin": "Вход",
  "/signup": "Регистрация",
  "/informatsiya": "Информация",
  "/oferta": "Публичная оферта",
  "/politika-konfidencialnosti": "Политика конфиденциальности",
  "/soglasie-pd": "Согласие на обработку персональных данных",
  "/vozvrat-sredstv": "Возврат средств",
  "/tarify": "Тарифы",
  "/kontakty": "Контакты",
  "/error-404": "Страница не найдена",
  "/modules/marketplaces/settings/common": "Маркетплейсы / Общие настройки",
  "/modules/marketplaces/settings/printers": "Маркетплейсы / Принтеры",
  "/modules/marketplaces/settings/stock-sync": "Маркетплейсы / Синхронизация остатков",
  "/modules/marketplaces/settings/offer-exclusions": "Маркетплейсы / Исключённые артикулы",
  "/modules/marketplaces/dimensions": "Маркетплейсы / Габариты",
  "/modules/marketplaces/barcodes": "Маркетплейсы / ШтрихКоды",
  "/modules/marketplaces/copying": "Маркетплейсы / Копирование карточек",
  "/modules/marketplaces/copying/jobs": "Маркетплейсы / Задачи копирования",
  "/modules/marketplaces/purchase": "Маркетплейсы / Опт/Закупка",
  "/modules/marketplaces/compare": "Маркетплейсы / Сравнение",
  "/modules/marketplaces/fbs/orders": "Маркетплейсы / FBS / Заказы",
  "/modules/marketplaces/ozon/settings": "Ozon / Настройки",
  "/modules/marketplaces/ozon/finances": "Ozon / Финансы / Отчеты",
  "/modules/marketplaces/ozon/finances/statistics": "Ozon / Финансы / Статистика",
  "/modules/marketplaces/ozon/promotions": "Ozon / Акции",
  "/modules/marketplaces/ozon/orders-feed": "Ozon / Лента заказов",
  "/modules/marketplaces/ozon/fby/supply": "Ozon / FBY / Поставки",
  "/modules/marketplaces/ozon/fby/settings": "Ozon / FBY / Настройки",
  "/modules/marketplaces/wb/settings": "WB / Настройки",
  "/modules/marketplaces/wb/finances": "WB / Финансы",
  "/modules/marketplaces/wb/orders-feed": "WB / Лента заказов",
  "/modules/marketplaces/wb/promotions": "WB / Цены и скидки",
  "/modules/marketplaces/wb/fby/stocks": "WB / FBY / Остатки",
  "/modules/marketplaces/wb/fby/supply": "WB / FBY / Поставки",
  "/modules/marketplaces/wb/fby/settings": "WB / FBY / Настройки",
  "/modules/marketplaces/yandex/settings": "Yandex / Настройки",
  "/modules/marketplaces/yandex/fby/supply": "Yandex / FBY / Поставки",
  "/modules/marketplaces/moysklad/settings": "МойСклад / Настройки",
  "/modules/moysklad/settings": "МойСклад / Настройки",
  "/modules/ai-memory/insights": "ИИ / Анализ",
  "/modules/ai-memory/settings": "ИИ / Настройки",
  "/modules/users/add": "Пользователи / Добавить",
  "/modules/users/list": "Пользователи / Список",
  "/admin/marketplaces/tariffs": "Админка / Тарифы marketplace",
  "/modules/settings": "Модули / Настройки",
};

const SEGMENT_TITLES: Record<string, string> = {
  modules: "",
  create: "Создать",
  list: "Список",
  report: "Отчет",
  supply: "Снабжение",
  settings: "Настройки",
  statuses: "Статусы",
  categories: "Категории",
  kpk: "КПК",
  marketplaces: "Маркетплейсы",
  common: "Общие",
  printers: "Принтеры",
  ozon: "Ozon",
  fby: "FBY",
  wb: "WB",
  fbo: "FBO",
  fbs: "FBS",
  orders: "Заказы",
  stocks: "Остатки",
  barcodes: "ШтрихКоды",
  purchase: "Опт/Закупка",
  yandex: "Yandex",
  finances: "Финансы",
  statistics: "Статистика",
  promotions: "Акции",
  moysklad: "МойСклад",
  "ai-memory": "ИИ",
  insights: "Анализ",
  users: "Пользователи",
  admin: "Админка",
  tariffs: "Тарифы",
  add: "Добавить",
  profile: "Профиль",
  support: "Поддержка",
  signin: "Вход",
  signup: "Регистрация",
};

function normalizePathname(pathname: string): string {
  const [rawPath] = pathname.split("?");
  const trimmed = rawPath.replace(/\/+$/, "");
  return trimmed || "/";
}

function prettifySegment(segment: string): string {
  const mapped = SEGMENT_TITLES[segment];
  if (mapped !== undefined) return mapped;
  const normalized = segment.replace(/[-_]+/g, " ").trim();
  if (!normalized) return "";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function getPageTitle(pathname: string): string {
  const normalizedPath = normalizePathname(pathname);
  const exactTitle = EXACT_ROUTE_TITLES[normalizedPath];
  if (exactTitle) return exactTitle;

  const parts = normalizedPath
    .split("/")
    .filter(Boolean)
    .map(prettifySegment)
    .filter(Boolean);

  return parts.length ? parts.join(" / ") : "Главная";
}

export function formatDocumentTitle(title: string): string {
  const cleanTitle = title.trim();
  return cleanTitle ? `${cleanTitle} | ${APP_TITLE_SUFFIX}` : APP_TITLE_SUFFIX;
}

export { APP_TITLE_SUFFIX };
